module.exports = __webpack_public_path__ + "img/na.ee974fd1.svg";